import { vttToJson, searchVtt, removeOldMarkers, setMarkers } from './search-vtt';

describe('Caption search functions', () => {
  describe('vttToJson', () => {
    it('Does not error if no captions are provided', async () => {
      const result = vttToJson(null);
      expect(result).toStrictEqual(null);
    });
  });

  describe('searchVtt', () => {
    it('Does not error if no keyword is provided', async () => {
      const player = [];
      const searchKeyword = '';
      const result = searchVtt(player, searchKeyword);
      expect(result).toStrictEqual(undefined);
    });
    it('Does not error if no player is provided', async () => {
      const player = undefined;
      const searchKeyword = 'people';
      const result = searchVtt(player, searchKeyword);
      expect(result).toStrictEqual(undefined);
    });
  });
  describe('removeOldMarkers', () => {
    it('Does not error if no player is provided', async () => {
      const player = undefined;
      const result = removeOldMarkers(player);
      expect(result).toStrictEqual(undefined);
    });
  });
  describe('setMarkers', () => {
    it('Does not error if no points are provided', async () => {
      const player = [];
      const points = undefined;
      const result = setMarkers(player, points);
      expect(result).toStrictEqual(undefined);
    });
    it('Does not error if no player is provided', async () => {
      const player = undefined;
      const points = [1, 2, 3];
      const result = setMarkers(player, points);
      expect(result).toStrictEqual(undefined);
    });
  });
});
